/* eslint-disable @typescript-eslint/no-explicit-any */
import { RouteObject } from 'react-router-dom';
import Protected from 'components/auth/Protected';
import { lazy, Suspense } from 'react';
import FlyAshPaymentPending from 'pages/challan/flyAsh/payment-pending/FlyAshPaymentPending';
import PaymentInitiated from 'pages/challan/coal-iron-ore/initiated-payment/PaymentInitiated';
import { challanUpdateLoader } from 'loaders/challanUpdateLoader';
import TruckerPaymentCheckList from 'pages/payments/trucker-payments/check-list/TruckerPaymentCheckList';
import TruckerPaymentApprovalList from 'pages/payments/trucker-payments/approval-list/TruckerPaymentApprovalList';
import TruckerPaymentPaidList from 'pages/payments/trucker-payments/payment-list/TruckerPaymentPaidList';

// const FlyAshPaymentPending = lazy(
//   () => import('pages/challan/flyAsh/payment-pending/FlyAshPaymentPending')
// );
const QuickPayment = lazy(
  () => import('pages/payments/quick-payment/QuickPayment')
);
const QuickPaymentList = lazy(
  () => import('pages/payments/quick-payment-list/QuickPaymentList')
);
const TransactionList = lazy(
  () => import('pages/payments/transaction-history/TransactionList')
);
const PaymentPending = lazy(
  () => import('pages/challan/coal-iron-ore/payment-pending/PaymentPending')
);

const ChallanApproval = lazy(
  () => import('pages/challan/coal-iron-ore/challan-approval/ChallanApproval')
);
const PodApproval = lazy(
  () => import('pages/challan/coal-iron-ore/pod-approval/PodApproval')
);
const CanceledIronOreChallan = lazy(
  () =>
    import(
      'pages/challan/coal-iron-ore/canceled-challan/CanceledIronOreChallan'
    )
);
// const FlyAshPaymentPending = lazy(
//   () => import('pages/challan/flyAsh/FlyAshPaymentPending')
// );
const FlyAshPaymentInitiated = lazy(
  () => import('pages/challan/flyAsh/FlyAshPaymentInitiated')
);
const CanceledFlyAshChallan = lazy(
  () => import('pages/challan/flyAsh/CanceledFlyAshChallan')
);
const CreateChallan = lazy(
  () => import('pages/challan/coal-iron-ore/CreateChallan')
);
const TruckerPaymentList = lazy(
  () => import('pages/payments/trucker-payments/TruckerPaymentList')
);
const CreateInvoices = lazy(
  () => import('pages/vendor-invoices/create-invoice-list/CreateInvoices')
);
const CheckInvoices = lazy(
  () => import('pages/vendor-invoices/check-invoices-list/CheckInvoices')
);
const PaidInvoices = lazy(
  () => import('pages/vendor-invoices/paid-invoices-list/PaidInvoices')
);
const RejectedInvoices = lazy(
  () => import('pages/vendor-invoices/rejected-invoices-list/RejectedInvoices')
);
const BillValidation = lazy(
  () => import('pages/vendor-invoices/create-invoice-list/BillValidation')
);

export function SuspenseWrapper({ children }: { children: any }) {
  return <Suspense fallback={<div>Loading...</div>}>{children}</Suspense>;
}

const paymentsRoutes: RouteObject[] = [
  {
    path: 'quick-payment',
    element: (
      <Protected action="payer" module={'Quick Payment'}>
        <SuspenseWrapper>
          <QuickPayment />
        </SuspenseWrapper>
      </Protected>
    )
  },
  {
    path: 'quick-payment-list',
    element: (
      <Protected action={['view', 'payer']} module={'Quick Payment'}>
        <SuspenseWrapper>
          <QuickPaymentList />
        </SuspenseWrapper>
      </Protected>
    )
  },
  {
    path: 'payment-history',
    element: (
      <Protected action="view" module={'Payment History'}>
        <SuspenseWrapper>
          <TransactionList />
        </SuspenseWrapper>
      </Protected>
    )
  },
  {
    path: 'coal-iron-ore',
    children: [
      {
        path: 'new',
        element: (
          <Protected action="maker" module={'Coal/Iron Ore'}>
            <SuspenseWrapper>
              <CreateChallan isUpdate={false} />
            </SuspenseWrapper>
          </Protected>
        )
      },
      {
        path: 'update/:id',
        element: (
          <Protected action="edit" module={'Coal/Iron Ore'}>
            <SuspenseWrapper>
              <CreateChallan isUpdate={true} />
            </SuspenseWrapper>
          </Protected>
        ),
        loader: challanUpdateLoader
      },
      {
        path: 'payment-pending',
        element: (
          <Protected action={['view', 'payer']} module={'Coal/Iron Ore'}>
            <SuspenseWrapper>
              <PaymentPending />
            </SuspenseWrapper>
          </Protected>
        )
      },
      {
        path: 'payment-initiated',
        element: (
          <Protected action={['view', 'payer']} module={'Coal/Iron Ore POD'}>
            {/* <SuspenseWrapper>
            </SuspenseWrapper> */}
            <PaymentInitiated />
          </Protected>
        )
      },
      {
        path: 'challan-approval',
        element: (
          <Protected action="checker" module={'Coal/Iron Ore POD'}>
            <SuspenseWrapper>
              {/* Check POD */}
              <ChallanApproval />
            </SuspenseWrapper>
          </Protected>
        )
      },
      {
        path: 'pod-approval',
        element: (
          <Protected action="approver" module={'Coal/Iron Ore POD'}>
            <SuspenseWrapper>
              <PodApproval />
            </SuspenseWrapper>
          </Protected>
        )
      },
      {
        path: 'canceled-challans',
        element: (
          <Protected action="view" module={'Cancelled Coal/Iron ore Challans'}>
            <SuspenseWrapper>
              <CanceledIronOreChallan />
            </SuspenseWrapper>
          </Protected>
        )
      }
    ]
  },
  {
    path: 'flyAsh',
    children: [
      {
        path: 'payment-pending',
        element: (
          <Protected action={['view', 'payer']} module={'FlyAsh'}>
            {/* <SuspenseWrapper> */}
            <FlyAshPaymentPending />
            {/* <p>Flyash Challan Payment Pending</p> */}
            {/* </SuspenseWrapper> */}
          </Protected>
        )
      },
      {
        path: 'payment-initiated',
        element: (
          <Protected action={['view', 'payer']} module={'FlyAsh'}>
            <SuspenseWrapper>
              <FlyAshPaymentInitiated />
            </SuspenseWrapper>
          </Protected>
        )
      },
      {
        path: 'canceled-challans',
        element: (
          <Protected action="view" module={'Cancelled FlyAsh Challans'}>
            <SuspenseWrapper>
              <CanceledFlyAshChallan />
            </SuspenseWrapper>
          </Protected>
        )
      }
    ]
  },

  {
    path: 'vendor-invoices',
    children: [
      {
        path: 'create-invoices',
        children: [
          {
            index: true,
            element: (
              <Protected action="view" module={'Vendor Invoices'}>
                <SuspenseWrapper>
                  <CreateInvoices />
                </SuspenseWrapper>
              </Protected>
            )
          },
          {
            path: 'scan/:id',
            element: (
              <Protected action="maker" module={'Vendor Invoices'}>
                <SuspenseWrapper>
                  <BillValidation />
                </SuspenseWrapper>
              </Protected>
            )
          }
        ]
      },
      {
        path: 'check-invoices',
        element: (
          <Protected action="checker" module={'Vendor Invoices'}>
            <SuspenseWrapper>
              <CheckInvoices />
            </SuspenseWrapper>
          </Protected>
        )
      },
      {
        path: 'paid-invoices',
        element: (
          <Protected action="payer" module={'Vendor Invoices'}>
            <SuspenseWrapper>
              <PaidInvoices />
            </SuspenseWrapper>
          </Protected>
        )
      },
      {
        path: 'rejected-invoices',
        element: (
          <Protected action="view" module={'Rejected Invoices'}>
            <SuspenseWrapper>
              <RejectedInvoices />
            </SuspenseWrapper>
          </Protected>
        )
      }
    ]
  },
  // {
  //   path: 'trucker-payments/:tab',
  //   element: (
  //     <Protected action="view" module={'trucker_payments'}>
  //       <SuspenseWrapper>
  //         <TruckerPaymentList />
  //       </SuspenseWrapper>
  //     </Protected>
  //   )
  // },
  {
    path: 'trucker-payments',
    children: [
      {
        path: 'pending-list',
        element: (
          <Protected action="view" module={'Trucker Payments'}>
            <SuspenseWrapper>
              <TruckerPaymentList />
            </SuspenseWrapper>
          </Protected>
        )
      },
      {
        path: 'checking-list',
        element: (
          // <Protected action="view" module={'checking_list'}>
          <Protected action="checker" module={'Trucker Payments'}>
            {/* <SuspenseWrapper> */}
            <TruckerPaymentCheckList />
            {/* </SuspenseWrapper> */}
          </Protected>
        )
      },
      {
        path: 'approval-list',
        element: (
          <Protected action="approver" module={'Trucker Payments'}>
            {/* <SuspenseWrapper> */}
            <TruckerPaymentApprovalList />
            {/* </SuspenseWrapper> */}
          </Protected>
        )
      },
      {
        path: 'payment-list',
        element: (
          <Protected action="payer" module={'Trucker Payments'}>
            {/* <SuspenseWrapper> */}
            <TruckerPaymentPaidList />
            {/* </SuspenseWrapper> */}
          </Protected>
        )
      }
    ]
  }
];

export default paymentsRoutes;
